import BackgroundImg from '../../assets/portfolio/newport/hero-newport.webp';

export const NewportBanner = {
  title: 'Newport Folk Festival',
  description: 'Bose AR app integration',
  background: BackgroundImg,
}
